const personalField = {
    firstName: '',
    middleName: '',
    lastName: '',
    address: '',
    phone: '',
    email:''
  
  }
  
  const educationField = {
    schoolName: '',
    schoolCity: '',
    titleOfStudy: '',
    from:'',
    to:''
  
  }

  const experienceField = {
      companyName:'',
      positionTitle:'',
      location:'',
      from:'',
      to:''
  }


  export {personalField, educationField, experienceField}